// extracted by mini-css-extract-plugin
export default {"loaderBox":"Loader_loaderBox__chWoN","loader":"Loader_loader__0uGhM","rotate":"Loader_rotate__iNDr2","loaderText":"Loader_loaderText__UZpeX"};